export default "__VITE_ASSET__Cd1l8i_n__"